import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"
import _imports_0 from '@/assets/logo.png'


const _hoisted_1 = { class: "sticky top-0 z-50 bg-white border-b border-neutral-100 shadow-sm" }
const _hoisted_2 = { class: "max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" }
const _hoisted_3 = { class: "flex items-center justify-between h-18 py-4" }
const _hoisted_4 = { class: "hidden md:flex items-center gap-1" }
const _hoisted_5 = { class: "hidden md:flex items-center" }
const _hoisted_6 = { class: "relative" }
const _hoisted_7 = {
  key: 0,
  class: "absolute top-full left-0 mt-2 w-72 bg-white border border-neutral-200 rounded-2xl shadow-2xl overflow-hidden z-50"
}
const _hoisted_8 = { key: 0 }
const _hoisted_9 = ["onMousedown"]
const _hoisted_10 = { class: "flex-1 text-sm text-neutral-700 truncate" }
const _hoisted_11 = ["onMousedown"]
const _hoisted_12 = { key: 1 }
const _hoisted_13 = ["onMousedown"]
const _hoisted_14 = { class: "flex-1 text-sm text-neutral-700 truncate" }
const _hoisted_15 = { class: "flex items-center gap-3 px-4 py-2.5 cursor-pointer pb-3" }
const _hoisted_16 = { class: "text-sm text-neutral-700" }
const _hoisted_17 = { class: "font-semibold text-primary-600" }
const _hoisted_18 = { class: "hidden md:flex items-center gap-3" }
const _hoisted_19 = {
  key: 0,
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}
const _hoisted_20 = {
  key: 1,
  class: "h-6 w-6",
  fill: "none",
  viewBox: "0 0 24 24",
  stroke: "currentColor"
}
const _hoisted_21 = {
  key: 0,
  class: "md:hidden border-t border-neutral-100 py-3 space-y-1"
}
const _hoisted_22 = { class: "px-1 pb-1 relative" }
const _hoisted_23 = { class: "relative" }
const _hoisted_24 = {
  key: 0,
  class: "absolute top-full left-1 right-1 mt-1 bg-white border border-neutral-200 rounded-2xl shadow-2xl overflow-hidden z-50"
}
const _hoisted_25 = { key: 0 }
const _hoisted_26 = ["onMousedown"]
const _hoisted_27 = { class: "flex-1 text-sm text-neutral-700 truncate" }
const _hoisted_28 = ["onMousedown"]
const _hoisted_29 = { key: 1 }
const _hoisted_30 = ["onMousedown"]
const _hoisted_31 = { class: "flex-1 text-sm text-neutral-700 truncate" }
const _hoisted_32 = { class: "flex items-center gap-3 px-4 py-2.5 cursor-pointer pb-3 hover:bg-neutral-50" }
const _hoisted_33 = { class: "text-sm text-neutral-700" }
const _hoisted_34 = { class: "font-semibold text-primary-600" }
const _hoisted_35 = { class: "pt-3 mt-2 border-t border-neutral-100 flex flex-col gap-2 px-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("header", _hoisted_1, [
    _createElementVNode("nav", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createVNode(_component_router_link, {
          to: "/",
          class: "flex items-center gap-2 flex-shrink-0"
        }, {
          default: _withCtx(() => [...(_cache[27] || (_cache[27] = [
            _createElementVNode("img", {
              src: _imports_0,
              alt: "Estate Rwanda",
              class: "h-10 w-auto"
            }, null, -1)
          ]))]),
          _: 1
        }),
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_router_link, {
            to: "/",
            class: "px-4 py-2 text-sm font-medium text-neutral-600 hover:text-primary-500 transition-colors rounded-md hover:bg-primary-50",
            "active-class": "text-primary-500 bg-primary-50",
            exact: ""
          }, {
            default: _withCtx(() => [...(_cache[28] || (_cache[28] = [
              _createTextVNode("Home", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/properties",
            class: "px-4 py-2 text-sm font-medium text-neutral-600 hover:text-primary-500 transition-colors rounded-md hover:bg-primary-50",
            "active-class": "text-primary-500 bg-primary-50"
          }, {
            default: _withCtx(() => [...(_cache[29] || (_cache[29] = [
              _createTextVNode("Properties", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/about",
            class: "px-4 py-2 text-sm font-medium text-neutral-600 hover:text-primary-500 transition-colors rounded-md hover:bg-primary-50",
            "active-class": "text-primary-500 bg-primary-50"
          }, {
            default: _withCtx(() => [...(_cache[30] || (_cache[30] = [
              _createTextVNode("About", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/blogs",
            class: "px-4 py-2 text-sm font-medium text-neutral-600 hover:text-primary-500 transition-colors rounded-md hover:bg-primary-50",
            "active-class": "text-primary-500 bg-primary-50"
          }, {
            default: _withCtx(() => [...(_cache[31] || (_cache[31] = [
              _createTextVNode("Blog", -1)
            ]))]),
            _: 1
          }),
          _createVNode(_component_router_link, {
            to: "/contact",
            class: "px-4 py-2 text-sm font-medium text-neutral-600 hover:text-primary-500 transition-colors rounded-md hover:bg-primary-50",
            "active-class": "text-primary-500 bg-primary-50"
          }, {
            default: _withCtx(() => [...(_cache[32] || (_cache[32] = [
              _createTextVNode("Contact", -1)
            ]))]),
            _: 1
          })
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, [
            _withDirectives(_createElementVNode("input", {
              ref: "desktopInput",
              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.searchQuery) = $event)),
              type: "text",
              placeholder: "Search properties...",
              autocomplete: "off",
              class: "w-52 lg:w-64 pl-9 pr-4 py-2 text-sm bg-neutral-50 border border-neutral-200 rounded-xl text-neutral-700 placeholder-neutral-400 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent focus:bg-white transition-all duration-200",
              onFocus: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openDropdown && _ctx.openDropdown(...args))),
              onBlur: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.scheduleClose && _ctx.scheduleClose(...args))),
              onKeydown: [
                _cache[3] || (_cache[3] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.submitFromInput && _ctx.submitFromInput(...args)), ["prevent"]), ["enter"])),
                _cache[4] || (_cache[4] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.moveDown && _ctx.moveDown(...args)), ["prevent"]), ["down"])),
                _cache[5] || (_cache[5] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.moveUp && _ctx.moveUp(...args)), ["prevent"]), ["up"])),
                _cache[6] || (_cache[6] = _withKeys(
//@ts-ignore
(...args) => (_ctx.closeDropdown && _ctx.closeDropdown(...args)), ["esc"]))
              ]
            }, null, 544), [
              [_vModelText, _ctx.searchQuery]
            ]),
            _cache[39] || (_cache[39] = _createElementVNode("svg", {
              class: "absolute left-2.5 top-1/2 -translate-y-1/2 w-4 h-4 text-neutral-400 pointer-events-none",
              fill: "none",
              stroke: "currentColor",
              viewBox: "0 0 24 24"
            }, [
              _createElementVNode("path", {
                "stroke-linecap": "round",
                "stroke-linejoin": "round",
                "stroke-width": "2",
                d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
              })
            ], -1)),
            (_ctx.dropdownOpen && _ctx.visibleSuggestions.length)
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                  (_ctx.filteredRecent.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                        _cache[35] || (_cache[35] = _createElementVNode("p", { class: "px-4 pt-3 pb-1 text-[10px] font-bold text-neutral-400 uppercase tracking-widest" }, "Recent", -1)),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredRecent, (item, i) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: 'r' + i,
                            class: _normalizeClass(["flex items-center gap-3 px-4 py-2.5 cursor-pointer transition-colors group", _ctx.highlightedIndex === i ? 'bg-primary-50' : 'hover:bg-neutral-50']),
                            onMousedown: _withModifiers(($event: any) => (_ctx.selectSuggestion(item)), ["prevent"])
                          }, [
                            _cache[34] || (_cache[34] = _createElementVNode("svg", {
                              class: "w-4 h-4 text-neutral-400 flex-shrink-0",
                              fill: "none",
                              stroke: "currentColor",
                              viewBox: "0 0 24 24"
                            }, [
                              _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                              })
                            ], -1)),
                            _createElementVNode("span", _hoisted_10, _toDisplayString(item), 1),
                            _createElementVNode("button", {
                              class: "opacity-0 group-hover:opacity-100 w-5 h-5 rounded-full hover:bg-neutral-200 flex items-center justify-center transition-all flex-shrink-0",
                              onMousedown: _withModifiers(($event: any) => (_ctx.deleteRecent(item)), ["prevent","stop"]),
                              title: "Remove"
                            }, [...(_cache[33] || (_cache[33] = [
                              _createElementVNode("svg", {
                                class: "w-3 h-3 text-neutral-500",
                                fill: "none",
                                stroke: "currentColor",
                                viewBox: "0 0 24 24"
                              }, [
                                _createElementVNode("path", {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2.5",
                                  d: "M6 18L18 6M6 6l12 12"
                                })
                              ], -1)
                            ]))], 40, _hoisted_11)
                          ], 42, _hoisted_9))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.filteredPopular.length)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                        _createElementVNode("p", {
                          class: _normalizeClass(["px-4 pt-3 pb-1 text-[10px] font-bold text-neutral-400 uppercase tracking-widest", _ctx.filteredRecent.length ? 'border-t border-neutral-100' : ''])
                        }, "Popular", 2),
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredPopular, (item, i) => {
                          return (_openBlock(), _createElementBlock("div", {
                            key: 'p' + i,
                            class: _normalizeClass(["flex items-center gap-3 px-4 py-2.5 cursor-pointer transition-colors", _ctx.highlightedIndex === _ctx.filteredRecent.length + i ? 'bg-primary-50' : 'hover:bg-neutral-50']),
                            onMousedown: _withModifiers(($event: any) => (_ctx.selectSuggestion(item)), ["prevent"])
                          }, [
                            _cache[36] || (_cache[36] = _createElementVNode("svg", {
                              class: "w-4 h-4 text-neutral-400 flex-shrink-0",
                              fill: "none",
                              stroke: "currentColor",
                              viewBox: "0 0 24 24"
                            }, [
                              _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                              })
                            ], -1)),
                            _createElementVNode("span", _hoisted_14, _toDisplayString(item), 1)
                          ], 42, _hoisted_13))
                        }), 128))
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.searchQuery.trim() && !_ctx.filteredRecent.includes(_ctx.searchQuery.trim()))
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 2,
                        class: _normalizeClass(["border-t border-neutral-100", _ctx.highlightedIndex === _ctx.filteredRecent.length + _ctx.filteredPopular.length ? 'bg-primary-50' : 'hover:bg-neutral-50']),
                        onMousedown: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.selectSuggestion(_ctx.searchQuery.trim())), ["prevent"]))
                      }, [
                        _createElementVNode("div", _hoisted_15, [
                          _cache[38] || (_cache[38] = _createElementVNode("svg", {
                            class: "w-4 h-4 text-primary-500 flex-shrink-0",
                            fill: "none",
                            stroke: "currentColor",
                            viewBox: "0 0 24 24"
                          }, [
                            _createElementVNode("path", {
                              "stroke-linecap": "round",
                              "stroke-linejoin": "round",
                              "stroke-width": "2",
                              d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                            })
                          ], -1)),
                          _createElementVNode("span", _hoisted_16, [
                            _cache[37] || (_cache[37] = _createTextVNode("Search for ", -1)),
                            _createElementVNode("span", _hoisted_17, "\"" + _toDisplayString(_ctx.searchQuery.trim()) + "\"", 1)
                          ])
                        ])
                      ], 34))
                    : _createCommentVNode("", true)
                ]))
              : _createCommentVNode("", true)
          ])
        ]),
        _createElementVNode("div", _hoisted_18, [
          (_ctx.isAuthenticated)
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createVNode(_component_router_link, {
                  to: _ctx.isAdmin ? '/admin' : '/agent',
                  class: "px-4 py-2 text-sm font-medium text-neutral-600 hover:text-primary-500 transition-colors"
                }, {
                  default: _withCtx(() => [...(_cache[40] || (_cache[40] = [
                    _createTextVNode("Dashboard", -1)
                  ]))]),
                  _: 1
                }, 8, ["to"]),
                _createElementVNode("button", {
                  onClick: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.handleLogout && _ctx.handleLogout(...args))),
                  class: "px-5 py-2 text-sm font-semibold text-white bg-primary-500 hover:bg-primary-600 rounded-lg transition-colors shadow-sm"
                }, "Logout")
              ], 64))
            : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                _createVNode(_component_router_link, {
                  to: "/signin",
                  class: "px-4 py-2 text-sm font-medium text-primary-500 hover:text-primary-600 transition-colors"
                }, {
                  default: _withCtx(() => [...(_cache[41] || (_cache[41] = [
                    _createTextVNode("Sign In", -1)
                  ]))]),
                  _: 1
                }),
                _createVNode(_component_router_link, {
                  to: "/signup",
                  class: "px-5 py-2 text-sm font-semibold text-white bg-primary-500 hover:bg-primary-600 rounded-lg transition-colors shadow-sm"
                }, {
                  default: _withCtx(() => [...(_cache[42] || (_cache[42] = [
                    _createTextVNode("Sign Up", -1)
                  ]))]),
                  _: 1
                })
              ], 64))
        ]),
        _createElementVNode("button", {
          onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.mobileMenuOpen = !_ctx.mobileMenuOpen)),
          class: "md:hidden p-2 rounded-md text-neutral-600 hover:text-primary-500 hover:bg-primary-50 transition-colors",
          "aria-label": "Toggle menu"
        }, [
          (!_ctx.mobileMenuOpen)
            ? (_openBlock(), _createElementBlock("svg", _hoisted_19, [...(_cache[43] || (_cache[43] = [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M4 6h16M4 12h16M4 18h16"
                }, null, -1)
              ]))]))
            : (_openBlock(), _createElementBlock("svg", _hoisted_20, [...(_cache[44] || (_cache[44] = [
                _createElementVNode("path", {
                  "stroke-linecap": "round",
                  "stroke-linejoin": "round",
                  "stroke-width": "2",
                  d: "M6 18L18 6M6 6l12 12"
                }, null, -1)
              ]))]))
        ])
      ]),
      (_ctx.mobileMenuOpen)
        ? (_openBlock(), _createElementBlock("div", _hoisted_21, [
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _withDirectives(_createElementVNode("input", {
                  "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.searchQuery) = $event)),
                  type: "text",
                  placeholder: "Search properties...",
                  autocomplete: "off",
                  class: "w-full pl-9 pr-4 py-2.5 text-sm bg-neutral-50 border border-neutral-200 rounded-xl text-neutral-700 placeholder-neutral-400 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent transition-all",
                  onFocus: _cache[11] || (_cache[11] = 
//@ts-ignore
(...args) => (_ctx.openDropdown && _ctx.openDropdown(...args))),
                  onBlur: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.scheduleClose && _ctx.scheduleClose(...args))),
                  onKeydown: [
                    _cache[13] || (_cache[13] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.submitFromInput && _ctx.submitFromInput(...args)), ["prevent"]), ["enter"])),
                    _cache[14] || (_cache[14] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.moveDown && _ctx.moveDown(...args)), ["prevent"]), ["down"])),
                    _cache[15] || (_cache[15] = _withKeys(_withModifiers(
//@ts-ignore
(...args) => (_ctx.moveUp && _ctx.moveUp(...args)), ["prevent"]), ["up"])),
                    _cache[16] || (_cache[16] = _withKeys(
//@ts-ignore
(...args) => (_ctx.closeDropdown && _ctx.closeDropdown(...args)), ["esc"]))
                  ]
                }, null, 544), [
                  [_vModelText, _ctx.searchQuery]
                ]),
                _cache[45] || (_cache[45] = _createElementVNode("svg", {
                  class: "absolute left-2.5 top-1/2 -translate-y-1/2 w-4 h-4 text-neutral-400 pointer-events-none",
                  fill: "none",
                  stroke: "currentColor",
                  viewBox: "0 0 24 24"
                }, [
                  _createElementVNode("path", {
                    "stroke-linecap": "round",
                    "stroke-linejoin": "round",
                    "stroke-width": "2",
                    d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                  })
                ], -1))
              ]),
              (_ctx.dropdownOpen && _ctx.visibleSuggestions.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                    (_ctx.filteredRecent.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                          _cache[48] || (_cache[48] = _createElementVNode("p", { class: "px-4 pt-3 pb-1 text-[10px] font-bold text-neutral-400 uppercase tracking-widest" }, "Recent", -1)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredRecent, (item, i) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: 'mr' + i,
                              class: _normalizeClass(["flex items-center gap-3 px-4 py-2.5 cursor-pointer transition-colors group", _ctx.highlightedIndex === i ? 'bg-primary-50' : 'hover:bg-neutral-50']),
                              onMousedown: _withModifiers(($event: any) => (_ctx.selectSuggestion(item)), ["prevent"])
                            }, [
                              _cache[47] || (_cache[47] = _createElementVNode("svg", {
                                class: "w-4 h-4 text-neutral-400 flex-shrink-0",
                                fill: "none",
                                stroke: "currentColor",
                                viewBox: "0 0 24 24"
                              }, [
                                _createElementVNode("path", {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: "M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"
                                })
                              ], -1)),
                              _createElementVNode("span", _hoisted_27, _toDisplayString(item), 1),
                              _createElementVNode("button", {
                                class: "opacity-0 group-hover:opacity-100 w-5 h-5 rounded-full hover:bg-neutral-200 flex items-center justify-center transition-all flex-shrink-0",
                                onMousedown: _withModifiers(($event: any) => (_ctx.deleteRecent(item)), ["prevent","stop"])
                              }, [...(_cache[46] || (_cache[46] = [
                                _createElementVNode("svg", {
                                  class: "w-3 h-3 text-neutral-500",
                                  fill: "none",
                                  stroke: "currentColor",
                                  viewBox: "0 0 24 24"
                                }, [
                                  _createElementVNode("path", {
                                    "stroke-linecap": "round",
                                    "stroke-linejoin": "round",
                                    "stroke-width": "2.5",
                                    d: "M6 18L18 6M6 6l12 12"
                                  })
                                ], -1)
                              ]))], 40, _hoisted_28)
                            ], 42, _hoisted_26))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.filteredPopular.length)
                      ? (_openBlock(), _createElementBlock("div", _hoisted_29, [
                          _createElementVNode("p", {
                            class: _normalizeClass(["px-4 pt-3 pb-1 text-[10px] font-bold text-neutral-400 uppercase tracking-widest", _ctx.filteredRecent.length ? 'border-t border-neutral-100' : ''])
                          }, "Popular", 2),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.filteredPopular, (item, i) => {
                            return (_openBlock(), _createElementBlock("div", {
                              key: 'mp' + i,
                              class: _normalizeClass(["flex items-center gap-3 px-4 py-2.5 cursor-pointer transition-colors", _ctx.highlightedIndex === _ctx.filteredRecent.length + i ? 'bg-primary-50' : 'hover:bg-neutral-50']),
                              onMousedown: _withModifiers(($event: any) => (_ctx.selectSuggestion(item)), ["prevent"])
                            }, [
                              _cache[49] || (_cache[49] = _createElementVNode("svg", {
                                class: "w-4 h-4 text-neutral-400 flex-shrink-0",
                                fill: "none",
                                stroke: "currentColor",
                                viewBox: "0 0 24 24"
                              }, [
                                _createElementVNode("path", {
                                  "stroke-linecap": "round",
                                  "stroke-linejoin": "round",
                                  "stroke-width": "2",
                                  d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                                })
                              ], -1)),
                              _createElementVNode("span", _hoisted_31, _toDisplayString(item), 1)
                            ], 42, _hoisted_30))
                          }), 128))
                        ]))
                      : _createCommentVNode("", true),
                    (_ctx.searchQuery.trim() && !_ctx.filteredRecent.includes(_ctx.searchQuery.trim()))
                      ? (_openBlock(), _createElementBlock("div", {
                          key: 2,
                          class: "border-t border-neutral-100",
                          onMousedown: _cache[17] || (_cache[17] = _withModifiers(($event: any) => (_ctx.selectSuggestion(_ctx.searchQuery.trim())), ["prevent"]))
                        }, [
                          _createElementVNode("div", _hoisted_32, [
                            _cache[51] || (_cache[51] = _createElementVNode("svg", {
                              class: "w-4 h-4 text-primary-500 flex-shrink-0",
                              fill: "none",
                              stroke: "currentColor",
                              viewBox: "0 0 24 24"
                            }, [
                              _createElementVNode("path", {
                                "stroke-linecap": "round",
                                "stroke-linejoin": "round",
                                "stroke-width": "2",
                                d: "M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                              })
                            ], -1)),
                            _createElementVNode("span", _hoisted_33, [
                              _cache[50] || (_cache[50] = _createTextVNode("Search for ", -1)),
                              _createElementVNode("span", _hoisted_34, "\"" + _toDisplayString(_ctx.searchQuery.trim()) + "\"", 1)
                            ])
                          ])
                        ], 32))
                      : _createCommentVNode("", true)
                  ]))
                : _createCommentVNode("", true)
            ]),
            _createVNode(_component_router_link, {
              to: "/",
              class: "block px-4 py-2.5 text-sm font-medium text-neutral-700 hover:text-primary-500 hover:bg-primary-50 rounded-md transition-colors",
              onClick: _cache[18] || (_cache[18] = ($event: any) => (_ctx.mobileMenuOpen = false)),
              exact: ""
            }, {
              default: _withCtx(() => [...(_cache[52] || (_cache[52] = [
                _createTextVNode("Home", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: "/properties",
              class: "block px-4 py-2.5 text-sm font-medium text-neutral-700 hover:text-primary-500 hover:bg-primary-50 rounded-md transition-colors",
              onClick: _cache[19] || (_cache[19] = ($event: any) => (_ctx.mobileMenuOpen = false))
            }, {
              default: _withCtx(() => [...(_cache[53] || (_cache[53] = [
                _createTextVNode("Properties", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: "/about",
              class: "block px-4 py-2.5 text-sm font-medium text-neutral-700 hover:text-primary-500 hover:bg-primary-50 rounded-md transition-colors",
              onClick: _cache[20] || (_cache[20] = ($event: any) => (_ctx.mobileMenuOpen = false))
            }, {
              default: _withCtx(() => [...(_cache[54] || (_cache[54] = [
                _createTextVNode("About", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: "/blogs",
              class: "block px-4 py-2.5 text-sm font-medium text-neutral-700 hover:text-primary-500 hover:bg-primary-50 rounded-md transition-colors",
              onClick: _cache[21] || (_cache[21] = ($event: any) => (_ctx.mobileMenuOpen = false))
            }, {
              default: _withCtx(() => [...(_cache[55] || (_cache[55] = [
                _createTextVNode("Blog", -1)
              ]))]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              to: "/contact",
              class: "block px-4 py-2.5 text-sm font-medium text-neutral-700 hover:text-primary-500 hover:bg-primary-50 rounded-md transition-colors",
              onClick: _cache[22] || (_cache[22] = ($event: any) => (_ctx.mobileMenuOpen = false))
            }, {
              default: _withCtx(() => [...(_cache[56] || (_cache[56] = [
                _createTextVNode("Contact", -1)
              ]))]),
              _: 1
            }),
            _createElementVNode("div", _hoisted_35, [
              (_ctx.isAuthenticated)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_router_link, {
                      to: _ctx.isAdmin ? '/admin' : '/agent',
                      class: "block px-4 py-2.5 text-sm font-medium text-neutral-700 hover:text-primary-500 text-center border border-neutral-300 rounded-lg transition-colors",
                      onClick: _cache[23] || (_cache[23] = ($event: any) => (_ctx.mobileMenuOpen = false))
                    }, {
                      default: _withCtx(() => [...(_cache[57] || (_cache[57] = [
                        _createTextVNode("Dashboard", -1)
                      ]))]),
                      _: 1
                    }, 8, ["to"]),
                    _createElementVNode("button", {
                      onClick: _cache[24] || (_cache[24] = 
//@ts-ignore
(...args) => (_ctx.handleLogout && _ctx.handleLogout(...args))),
                      class: "block w-full px-4 py-2.5 text-sm font-semibold text-white bg-primary-500 hover:bg-primary-600 text-center rounded-lg transition-colors"
                    }, "Logout")
                  ], 64))
                : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createVNode(_component_router_link, {
                      to: "/signin",
                      class: "block px-4 py-2.5 text-sm font-medium text-primary-500 hover:text-primary-600 text-center border border-primary-500 rounded-lg transition-colors",
                      onClick: _cache[25] || (_cache[25] = ($event: any) => (_ctx.mobileMenuOpen = false))
                    }, {
                      default: _withCtx(() => [...(_cache[58] || (_cache[58] = [
                        _createTextVNode("Sign In", -1)
                      ]))]),
                      _: 1
                    }),
                    _createVNode(_component_router_link, {
                      to: "/signup",
                      class: "block px-4 py-2.5 text-sm font-semibold text-white bg-primary-500 hover:bg-primary-600 text-center rounded-lg transition-colors",
                      onClick: _cache[26] || (_cache[26] = ($event: any) => (_ctx.mobileMenuOpen = false))
                    }, {
                      default: _withCtx(() => [...(_cache[59] || (_cache[59] = [
                        _createTextVNode("Sign Up", -1)
                      ]))]),
                      _: 1
                    })
                  ], 64))
            ])
          ]))
        : _createCommentVNode("", true)
    ])
  ]))
}